import script from "./TermsAndConditionsDoctorView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TermsAndConditionsDoctorView.vue?vue&type=script&lang=ts&setup=true"

import "./TermsAndConditionsDoctorView.vue?vue&type=style&index=0&id=6d7787de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d7787de"]])

export default __exports__